import { render, staticRenderFns } from "./productProductionTrend.vue?vue&type=template&id=f63a27d0&scoped=true&"
import script from "./productProductionTrend.vue?vue&type=script&lang=js&"
export * from "./productProductionTrend.vue?vue&type=script&lang=js&"
import style0 from "./productProductionTrend.vue?vue&type=style&index=0&id=f63a27d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63a27d0",
  null
  
)

export default component.exports